const getAreasOfDots = (startPos: number, endPos: number, height: number, dotsCount: number) => {
    const areas = dotsCount;
    const width = endPos - startPos;
    const area = width / (areas - 1);

    return [...Array(areas)].map((_, idx) => (
        {
            x: idx * area + startPos - area * .55,
            y: 0,
            width: area,
            height,
        }
    ));
};

export default getAreasOfDots;
